import { useCallback, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { applyEdgeChanges } from '../core';
import type { Edge, EdgeChange } from '../core';

/** v11 `useEdgesState(initialEdges)` → `[edges, setEdges, onEdgesChange]`; changes are applied with `applyEdgeChanges`. */
export const useEdgesState = <TEdge extends Edge>(
  initialEdges: TEdge[],
): [TEdge[], Dispatch<SetStateAction<TEdge[]>>, (changes: EdgeChange[]) => void] => {
  const [edges, setEdges] = useState(initialEdges);
  const onEdgesChange = useCallback((changes: EdgeChange[]) => setEdges((current) => applyEdgeChanges(changes, current)), []);
  return [edges, setEdges, onEdgesChange];
};
